import styled from 'styled-components';
import Box from '@mui/material/Box';


export const NavigationBox = styled(Box)`
      .hamburger{
 
   color: black;
       font-size: 28px;
    margin: 0 10px -14px 0;

}

@media (min-width: 900px){
    justify-content: right;
    display: flex; 
    gap: 10px;
    padding: 0 0 0 15%;
    &:after{

            flex-grow: 0.1;
            content: '|';
            font-size: 40px;
            font-weight: 100;
            display: flex;
            gap: 30;
            color: #707070;
            justify-content: flex-end;
            align-items: center;
}

.active {
    color: rgb(27, 74, 131) !important;
    font-weight: 600;
  }

button.MuiButtonBase-root {

    color: #000000;
    text-transform: capitalize;
                           @media screen and (min-device-width: 1098px) and (max-device-width: 1299px) { 
       font-size: 12px;
      
    }
                               @media screen and (min-device-width: 900px) and (max-device-width: 1097px) { 
       font-size: 12px;
      
    }

    &:hover {
        color: #1B4A83;
        font-weight: 600;
        background-color: #fff;
      }
      &:visited {
        color: red;
      } 

     
}


`;

